import { SIZE_33 } from '@/lib/gridElements/size';

//kpis
import { totalFollowersConfig } from '@/lib/analytics/kpis/twitter/totalFollowers';
import { followersEvolutionConfig } from '@/lib/analytics/kpis/twitter/followersEvolution';
import { followersEvolutionPercentageConfig } from '@/lib/analytics/kpis/twitter/followersEvolutionPercentage';

//charts
import { followerGrowthHistoryConfig } from '@/lib/analytics/charts/twitter/followerGrowthHistory';
import { gainedLostFollowersConfig } from '@/lib/analytics/charts/twitter/gainedLostFollowers';

export const CommunityTwitter = [
    { ...totalFollowersConfig, size: SIZE_33 },
    { ...followersEvolutionConfig, size: SIZE_33 },
    { ...followersEvolutionPercentageConfig, size: SIZE_33 },
    followerGrowthHistoryConfig,
    gainedLostFollowersConfig
];

export const requestTwitterParams = [
    // TwitterAccountMetrics
    'followers',
    'followers_evolution',
    'followers_evolution_percentage',
    'followers_growth',
    'gained_lost_fans_history'
];
